import { Route, Routes } from "react-router-dom";

import { Routes as AdminRoutes } from "ui/modules/navigation";

import { PricingSearchPage } from "../pages/PricingSearchPage";
import { PricingDetailPage } from "../pages/PricingDetailPage";
import { PricingSchemesPage } from "../pages/PricingSchemesPage";
import { PricingDeviationsPage } from "../pages/PricingDeviationsPage";

import { PricingRouterCmp } from "./types";

const PricingRouter: PricingRouterCmp = () => (
  <Routes>
    <Route path={PricingSearchPage.route} element={<PricingSearchPage />} />
    <Route path={PricingDetailPage.route} element={<PricingDetailPage />} />
    <Route path={PricingSchemesPage.route} element={<PricingSchemesPage />} />
    <Route path={PricingDeviationsPage.route} element={<PricingDeviationsPage />} />
  </Routes>
);

PricingRouter.route = AdminRoutes.ModuleRouter;

export default PricingRouter;
